// extracted by mini-css-extract-plugin
module.exports = {"wrap":"PostTileImage_wrap__1UZkV","link":"PostTileImage_link__v2fZe","image":"PostTileImage_image__19HMj"};